import { render, staticRenderFns } from "./RegisterSchool.vue?vue&type=template&id=549eca11"
import script from "./RegisterSchool.vue?vue&type=script&lang=ts"
export * from "./RegisterSchool.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSchool.vue?vue&type=style&index=0&id=549eca11&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports